export enum BroadcastItems {
  BallFinal = 'BallFinal',
  BallEvent = 'BallEvent',
  PitchLive = 'PitchLive',
}
